import React from "react";

type Template = {
  id: number;
  name: string;
  description: string;
  createdAt: string;
};

type TemplateListProps = {
  templates: Template[];
};

const TemplateList: React.FC<TemplateListProps> = ({ templates }) => {
  return (
    <div>
      {templates.map((template) => (
        <div
          key={template.id}
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            marginBottom: "12px",
            padding: "12px",
          }}
        >
          <h3>{template.name}</h3>
          <p>{template.description}</p>
          <small>作成日: {template.createdAt}</small>
          <button
            style={{
              marginTop: "8px",
              marginLeft: "5px",
              padding: "6px 12px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => alert(`テンプレートID: ${template.id} の詳細表示`)}
          >
            詳細表示
          </button>
        </div>
      ))}
    </div>
  );
};

export default TemplateList;
